<template>
  <div :id="mapName" class="google-map" />
</template>
<script setup>
import { ref, toRefs, onMounted } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
  location: {
    type: Object,
    default: undefined
  }
});

const { location } = toRefs(props);

const i18n = useI18n();

const mapName = ref("google-map");

onMounted(() => {
  const libraries = ["places"].join(",");
  const language = i18n.locale.value;
  const apiKey = process.env.VUE_APP_GOOGLE_API_KEY;
  var scriptElements = document.querySelectorAll("script");
  let hasScript = false;

  for (var i = 0; i < scriptElements.length && !hasScript; i++) {
    var src = scriptElements[i].getAttribute("src");
    if (
      src &&
      src.includes(
        `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=${libraries}&language=${language}`
      )
    ) {
      hasScript = true;
    }
  }

  if (!hasScript) {
    const googleMapsScript = document.createElement("script");
    googleMapsScript.setAttribute(
      "src",
      `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=${libraries}&language=${language}`
    );
    googleMapsScript.defer = true;
    googleMapsScript.onload = () => changeSelector();
    document.head.appendChild(googleMapsScript);
  } else {
    if (window.google && window.google.maps) {
      changeSelector();
    } else {
      // Espera a que la API esté disponible
      const checkGoogleMapsLoaded = setInterval(() => {
        if (window.google && window.google.maps) {
          clearInterval(checkGoogleMapsLoaded);
          changeSelector();
        }
      }, 100);
    }
  }
});

const changeSelector = () => {
  setTimeout(() => {
    const element = document.getElementById(mapName.value);

    if (!window.google || !window.google.maps) {
      console.error("Google Maps API no está disponible");
      return;
    }

    var myLatlng = new window.google.maps.LatLng(
      location.value.latitude,
      location.value.longitude
    );
    const options = {
      zoom: 17,
      center: myLatlng
    };
    const map = new window.google.maps.Map(element, options);
    var marker = new window.google.maps.Marker({
      position: myLatlng,
      map: map,
      title: "location"
    });
  }, 250);
};
</script>
<style lang="scss"></style>
